import fetchApi from '~/common/fetchApi';

type SpeechTopUp = {
    currency: number;
    amount: number;
};

type SpeechBalance = {
    balance: number;
    totalToppedUp: number;
    totalUsed: number;
};

export const createSpeechTopUp = async (data: SpeechTopUp): Promise<{ redirect_url: string }> => {
    return await fetchApi.post<{ redirect_url: string }>('/speech/topup', data);
};

export const fetchSpeechBalance = async (): Promise<SpeechBalance> => {
    return await fetchApi.get<SpeechBalance>('/speech/balance');
};
